import { AxiosResponse } from 'axios';
import { csrfToken, instance } from '../db';

// お知らせ会員個別情報API
export const getMemberNewsList = async (
  limit: number,
  offset: number
): Promise<AxiosResponse> => {
  const response = await instance.get(
    `/news/members?limit=${limit}&offset=${offset}`,
    {
      headers: {
        'X-XSRF-TOKEN': csrfToken
      }
    }
  );
  return response;
};

// お知らせ会員個別情報(詳細)API
export const getMemberNews = async (
  newsId: number | string
): Promise<AxiosResponse> => {
  const response = await instance.get(`/news/members?id=${newsId}`, {
    headers: { 'X-XSRF-TOKEN': csrfToken }
  });
  return response;
};

// 新着建材情報取得API
export const getMaterialNewsList = async (
  limit: number,
  offset: number
): Promise<AxiosResponse> => {
  const response = await instance.get(
    `/products?limit=${limit}&offset=${offset}&order=6&method=1`,
    {
      headers: { 'X-XSRF-TOKEN': csrfToken }
    }
  );
  return response;
};
